import axios from 'axios';

// const BASE_URL = 'http://localhost:3001';

function upload(formData, BASE_URL) {
    // console.log('formData',formData)
    const url = `${BASE_URL}`;
    return axios
        .post(url, formData)
        // get data
        .then(function (x) {
            return x.data;
        })
        // add url field
        .finally(
            // x => {
            //     // return x.data;
            //     // console.log('x', x)
            //     // x.map(
            //     //     uploaded_item => Object.assign(
            //     //         {},
            //     //         uploaded_item, {
            //     //             url: `${BASE_URL}/images/${uploaded_item.id}`
            //     //         }
            //     //     )
            //     // );
            //     // console.log(uploaded_item)
            // }
        )
        .catch(error => {
            console.error(error);
            return Promise.reject(error);
        });
}

export {upload}


// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/components/base/upload/file_upload.service.js